import React from 'react';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
const CMP = (props: Partial<CustomIconComponentProps>) => (
  <svg viewBox="0 0 18 18" width={18} height={18}>
    <path
      id="列表_3_"
      fill="currentColor"
      data-name="列表 (3)"
      d="M87.308,74.462H81.077a.692.692,0,1,1,0-1.385h6.231a.692.692,0,1,1,0,1.385Zm0,3.462H81.077a.692.692,0,1,1,0-1.385h6.231a.692.692,0,1,1,0,1.385Zm0,5.538H81.077a.692.692,0,1,1,0-1.385h6.231a.692.692,0,1,1,0,1.385Zm0,3.462H81.077a.692.692,0,1,1,0-1.385h6.231a.692.692,0,0,1,0,1.385ZM76.231,79.308H72.077A2.08,2.08,0,0,1,70,77.231V73.077A2.079,2.079,0,0,1,72.077,71h4.154a2.079,2.079,0,0,1,2.077,2.077v4.154a2.079,2.079,0,0,1-2.077,2.077Zm-4.154-6.923a.693.693,0,0,0-.692.692v4.154a.694.694,0,0,0,.692.692h4.154a.694.694,0,0,0,.692-.692V73.077a.694.694,0,0,0-.692-.692ZM76.231,89H72.077A2.079,2.079,0,0,1,70,86.923V82.769a2.08,2.08,0,0,1,2.077-2.077h4.154a2.08,2.08,0,0,1,2.077,2.077v4.154A2.08,2.08,0,0,1,76.231,89Zm-4.154-6.923a.693.693,0,0,0-.692.692v4.154a.693.693,0,0,0,.692.692h4.154a.693.693,0,0,0,.692-.692V82.769a.693.693,0,0,0-.692-.692Zm0,0"
      transform="translate(-70 -71)"
      opacity="0.65"
    />
  </svg>
);

export default CMP;
